
<!-- <lib-app-manager  [platformURL]="platformURLDash" [princibleID]="loginID" [pinpoint]="pinpoint" [endpoint]="adminEndpointAPI" [doShowDashboard]=true [apiSignature]="APISingnature" (emitEvent)="onEmitEvent($event)"></lib-app-manager> -->


<dhhp-appManager  [platformURL]="platformURLDash" [princibleID]="loginID" [pinpoint]="pinpoint" [endpoint]="adminEndpointAPI" [doShowDashboard]=true [apiSignature]="APISingnature" (emitEvent)="onEmitEvent($event)"></dhhp-appManager>